import { DocTypeFiles } from 'shared/constants/docs';

type Props = {
	type?: DocTypeFiles;
};

export default function CreateFolderButton(_props: Props) {
	return null;
}
